module.exports = __webpack_public_path__ + "img/DSCN2039.8be66806.jpg";